// extracted by mini-css-extract-plugin
export default {"popupWrapper":"ImagePopup_popupWrapper__bd-Fj","closeButton":"ImagePopup_closeButton__g1bRx"};